/**
 * Debug / developer tools visibility — never shown to normal customers in production.
 */
const ADMIN_DEBUG_ROLES = new Set([
  'platform_owner',
  'super_admin',
  'platform_admin',
  'internal_admin',
]);

export function canShowDebugTools(user) {
  const role = String(user?.role || '').toLowerCase();
  if (!ADMIN_DEBUG_ROLES.has(role)) return false;

  const isDevelopment =
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_ENABLE_DEBUG_TOOLS === 'true';

  const featureFlagOn = process.env.REACT_APP_DEBUG_TOOLS === 'true';

  return Boolean(isDevelopment && featureFlagOn);
}
